import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { ChatMessage, isHonourBoard } from '../models';

@Component({
  selector: 'lib-honour-board-message',
  templateUrl: './honour-board-message.component.html',
  styles: [
    `
      .extra-small {
        font-size: 60%;
      }

      .total-row {
        border-top: 2px solid black !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HonourBoardMessageComponent {
  @Input() msg!: ChatMessage;
  isHonourBoard = isHonourBoard;

  constructor() {}
}
